import {
  mapState,
  mapActions,
} from 'vuex';

import Entry from '@/vuex/orm/models/Entry';

export default {

  data() {
    return {
      entriesLoaded: false,
    };
  },

  computed: {
    ...mapState({
      entries: state => state.entry.entries,
    }),
  },

  methods: {
    ...mapActions(['getEntries']),

    async loadEntries(fromDb) {
      // console.log('entries requested!');
      if (Entry.all().length === 0 || fromDb) {
        this.fetchEntries();
      } else {
        // console.log('entries already fetched!');
        this.entriesLoaded = true;
        Bus.$emit('entries_loaded');
      }

      // console.log('entries-loader.entries', Entry.all());
    },

    async fetchEntries() {
      // console.log('fetching entries...');
      await Entry.$fetch({
        // headers: { // does not work
        //   Authorization: `Bearer ${this.$auth.token()}`,
        // },
        query: {
          token: this.$auth.token(),
          // limit: 100,
          // l: 'list',
        },
      });

      this.entriesLoaded = true;
      // console.log('entries fetched!');
      Bus.$emit('entries_fetched');
    },
  },
};
